import { PageHero } from "../components/site/PageHero";
import { FadeUp, Eyebrow } from "../components/site/Motion";
import { CtaBand } from "../components/site/CtaBand";
import { ProjectTimeline } from "../components/site/ProjectTimeline";
import { IMG } from "../data/content";
import { PROJECTS } from "../data/projects";
import { useLang } from "../i18n/LangContext";

const Stat = ({ v, l, testId }) => (
  <div data-testid={testId} className="border-t border-[#D6CEBF] pt-5">
    <p className="font-serif text-6xl leading-none text-[#1C1917] sm:text-7xl">{v}</p>
    <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-stone-600">{l}</p>
  </div>
);

export default function Progetti() {
  const { t, lang } = useLang();
  const p = t.progetti;
  const countries = new Set(PROJECTS.map((x) => x.country)).size;
  const years = `${PROJECTS[0].year}–${PROJECTS[PROJECTS.length - 1].year}`;
  return (
    <main data-testid="progetti-page">
      <PageHero
        key={p.lines[0]}
        testId="progetti-hero"
        eyebrow={p.eyebrow}
        lines={p.lines}
        intro={p.intro}
        img={IMG.outdoor}
      />

      <section className="mx-auto max-w-7xl px-5 pb-16 sm:px-8">
        <FadeUp className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          <Stat v={PROJECTS.length} l={p.statProjects} testId="stat-projects" />
          <Stat v={countries} l={p.statCountries} testId="stat-countries" />
          <Stat v={years} l={p.statYears} testId="stat-years" />
        </FadeUp>
      </section>

      <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8">
        <FadeUp><Eyebrow>{p.listEyebrow}</Eyebrow></FadeUp>
        <ProjectTimeline projects={PROJECTS} lang={lang} />
      </section>

      <CtaBand title={p.cta.title} to="/contatti" label={p.cta.label} testId="progetti-cta" />
    </main>
  );
}
